import React from 'react';
import PropTypes from 'prop-types';
// explicitly import the CSS file before the React component, otherwise the styling breaks
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import { CATALOG_ITEM_IMAGE_PLACEHOLDER } from '../../constants';

const DetailsCardImages = ({ imageUrls }) => {
  const images = imageUrls.map(url => ({
    original: url || CATALOG_ITEM_IMAGE_PLACEHOLDER,
    thumbnail: url || CATALOG_ITEM_IMAGE_PLACEHOLDER,
  }));

  return (
    <ImageGallery
      showPlayButton={false}
      showFullscreenButton={false}
      showNav={false}
      showThumbnails={images.length > 1}
      items={images}
    />
  );
};

DetailsCardImages.defaultProps = {
  imageUrls: [CATALOG_ITEM_IMAGE_PLACEHOLDER],
};

DetailsCardImages.propTypes = {
  imageUrls: PropTypes.arrayOf(PropTypes.string),
};

export default DetailsCardImages;
